import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import PartnerUserSelectModal from "../common/PartnerUserSelectModal";
import ItemSelectModal from "../common/ItemSelectModal";
import UserSelectModal from "../common/UserSelectModal";
import WorkplaceSelectModal from "../common/WorkplaceSelectModal";
import WarehouseSelectModal from "../common/WarehouseSelectModal";
import WarehouseSectionSelectModal from "../common/WarehouseSectionSelectModal";
import Moment from 'moment';
import "moment/locale/ko";

let newFileID = 1;
let realFiles = [];
let tmpRealFiles = [];
function IncomingUpdateModal({ title, onClose, id, originRows, handleView, userTypeModalOption, qualityYnModalOption, MenuUpdateYN}) {
  const appStore = useContext(AppContext);
  const apiRef = useGridApiRef();
  const tabPanelRef = useRef();
  const [tabPanelHeight, setTabPanelHeight] = useState(0);
  const [originItemRows, setOriginItemRows] = useState([]);
  const [itemRows, setItemRows] = useState([]);
  const [updateItemRows, setUpdateItemRows] = useState([]);
  const [itemColumns, setItemColumns] = useState([]);
  const [originLotRows, setOriginLotRows] = useState([]);
  const [lotRows, setLotRows] = useState([]);
  const [updateLotRows, setUpdateLotRows] = useState([]);
  const [lotColumns, setLotColumns] = useState([]);
  const [userRows, setUserRows] = useState([]);
  const [updateUserRows, setUpdateUserRows] = useState([]);
  const [userColumns, setUserColumns] = useState([]);
  const [fileRows, setFileRows] = useState([]);
  const [originFileRows, setOriginFileRows] = useState([]);
  const [updateFileRows, setUpdateFileRows] = useState([]);
  const [fileColumns, setFileColumns] = useState([]);
  const [tabID, setTabID] = useState('1');
  const [inputs, setInputs] = useState({
    incoming_id: null,
    incoming_number: '',
    incoming_date:'',
    incoming_partner_id: 0,
    incoming_partner_name: '',
    incoming_partner_manager: '',
    incoming_partner_manager_phone: '',
    incoming_partner_manager_mail: '',
    incoming_bigo: '',
    incoming_purchase_id: null,
    incoming_purchase_number: '',
    incoming_ref_incoming_id: null
  });
  const [lotNoStartNumber, setLotNoStartNumber] = useState('1');
  const [lotOrderStartNumber, setLotOrderStartNumber] = useState('1');
  const [selectmodalTitle, setSelectModalTitle] = useState('');
  const [isSelectPartnerModalOpen, setSelectPartnerModalOpen] = useState(false);
  const [isSelectItemModalOpen, setSelectItemModalOpen] = useState(false);
  const [isSelectUserModalOpen, setSelectUserModalOpen] = useState(false);
  const [isSelectWorkplaceModalOpen, setSelectWorkplaceModalOpen] = useState(false);
  const [isSelectWarehouseModalOpen, setSelectWarehouseModalOpen] = useState(false);
  const [isSelectWarehouseSectionModalOpen, setSelectWarehouseSectionModalOpen] = useState(false);
  const [selectItemData, setSelectItemData] = useState('');
  const [selectUserData, setSelectUserData] = useState('');
  const [selectLotData, setSelectLotData] = useState('');
  const [selectModalType, setSelectModalType] = useState('');
  const [upperWorkplaceId, setUpperWorkplaceId] = useState(0);
  const [upperWarehouseId, setUpperWarehouseId] = useState(0);
  const [updateFlag, setUpdateFlag] = useState(MenuUpdateYN === 'Y' && originRows.some(row =>
    [row.incoming_user_id, row.reg_user_id, row.update_user_id].includes(Number(localStorage.getItem('user_id')))
  ));

  // 빠른 포맷터(필요 시 Moment 대체)
const fmtDateTime = (v) => {
  if (!v) return '';
  // 서버가 'YYYY-MM-DD HH:mm:ss'로 준다면 그대로 사용 권장.
  // 필요 시 아래처럼 현지시간 형식으로:
  // return new Date(v).toLocaleString('sv-SE');
  return v;
};

const handleInitSelect = () => {
  const t0 = performance.now();

  // 0) 초기화
  tmpRealFiles = [];
  setUpdateItemRows([]);
  setUpdateLotRows([]);
  setUpdateUserRows([]);
  setUpdateFileRows([]);

  const rows = originRows || [];
  const first = rows[0];
  if (!first) return;

  // 1) inputs 세팅 (여긴 비용 거의 X)
  setInputs({
    incoming_id: Number(first.incoming_id),
    incoming_number: first.incoming_number,
    incoming_date: first.incoming_date,
    incoming_partner_id: Number(first.incoming_partner_id),
    incoming_partner_name: first.incoming_partner_name,
    incoming_partner_manager: first.incoming_partner_manager,
    incoming_partner_manager_phone: first.incoming_partner_manager_phone,
    incoming_partner_manager_mail: first.incoming_partner_manager_mail,
    incoming_bigo: first.incoming_bigo,
    incoming_purchase_id: Number(first.incoming_purchase_id),
    incoming_purchase_number: first.incoming_purchase_number,
    incoming_ref_incoming_id: Number(first.incoming_ref_incoming_id),
  });

  setLotNoStartNumber(Number(String(first.incoming_number || '').slice(7)));

  // 2) 1패스로 전부 분류 + dedupe (Map)
  const itemMap = new Map(); // key: incoming_item_seq
  // lot은 기존 로직이 (lot_seq 동일 + incoming_item_id 동일) 중복 제거라서 그 조합으로 key
  const lotMap  = new Map(); // key: `${lot_incoming_item_lot_seq}|${incoming_item_id}`
  const userMap = new Map(); // key: incoming_user_seq
  const fileMap = new Map(); // key: incoming_file_id

  for (const r of rows) {
    // items
    if (r.incoming_item_seq !== undefined && !itemMap.has(r.incoming_item_seq)) {
      const spec = ((r.incoming_item_spec || '')
                    + appStore.ITEM_FULL_SPEC_MAKE(
                        r.incoming_item_width,
                        r.incoming_item_depth,
                        r.incoming_item_height
                      )
                  ).trim();
      itemMap.set(r.incoming_item_seq, {
        id: r.incoming_item_seq,
        incoming_item_id: r.incoming_item_id,
        incoming_item_name: r.incoming_item_name,
        incoming_item_spec: spec,
        incoming_item_count: r.incoming_item_count,
        incoming_quality_exam_yn: r.incoming_quality_exam_yn,
        incoming_save_section_id: r.incoming_save_section_id,
        incoming_save_section_name: r.incoming_save_section_name,
        incoming_save_warehouse_id: r.incoming_save_warehouse_id,
        incoming_save_warehouse_name: r.incoming_save_warehouse_name,
        incoming_save_workplace_id: r.incoming_save_workplace_id,
        incoming_save_workplace_name: r.incoming_save_workplace_name,
        row_type: 'O',
        update_type: 'N',
      });
    }

    // users
    if (r.incoming_user_seq !== undefined && !userMap.has(r.incoming_user_seq)) {
      userMap.set(r.incoming_user_seq, {
        id: r.incoming_user_seq,
        incoming_user_id: r.incoming_user_id,
        incoming_user_name: r.incoming_user_name,
        incoming_user_dept_name: r.incoming_user_dept_name,
        incoming_user_position_name: r.incoming_user_position_name,
        incoming_user_type: r.incoming_user_type,
        incoming_user_bigo: r.incoming_user_bigo,
        row_type: 'O',
        update_type: 'N',
      });
    }

    // files
    if (r.incoming_file_id !== undefined && !fileMap.has(r.incoming_file_id)) {
      fileMap.set(r.incoming_file_id, {
        id: r.incoming_file_id,
        file_name_sever: r.incoming_file_name_sever,
        file_size: r.incoming_file_size,
        file_type: r.incoming_file_type,
        file_extension: r.incoming_file_extension,
        file_name: r.incoming_file_name,
        file_type_name: r.incoming_file_type_name,
        file_size_dp: r.incoming_file_size_dp,
        reg_user_name: r.incoming_file_user_name,
        // Moment 대신 그대로 문자열 사용(대량 처리 시 Moment가 병목)
        reg_datetime: Moment(r.incoming_file_user_datetime).format('YYYY-MM-DD HH:mm:ss'),
        row_type: 'O',
        update_type: 'N',
      });
    }
  }

  axios.get('/api/p/Incoming/LotList',
      {
      params : {
        incoming_id : id
      }
    },
    { withCredentials: true }
  )
  .then((response) => {
    if(response.data.length > 0){

      var LotData = (response.data).filter((item, index) => {
        return (
          (response.data).findIndex((item2, index2) => {
            return typeof item.lot_incoming_item_lot_seq !== 'undefined' && item.lot_incoming_item_lot_seq === item2.lot_incoming_item_lot_seq;
          }) === index
        );
      });

      setLotRows(LotData.map((item, index) => ({
          id: item.lot_incoming_item_lot_seq,
          upper_id: item.incoming_item_seq,
          lot_no: item.lot_incoming_item_lotno,
          lot_incoming_item_id: item.lot_incoming_item_id,
          lot_incoming_item_name: item.lot_incoming_item_name,
          lot_incoming_item_spec: item.lot_incoming_item_spec,
          lot_incoming_quality_exam_yn: item.lot_incoming_quality_exam_yn,
          lot_incoming_save_workplace_id: item.lot_incoming_save_workplace_id,
          lot_incoming_save_workplace_name: item.lot_incoming_save_workplace_name,
          lot_incoming_save_warehouse_id: item.lot_incoming_save_warehouse_id,
          lot_incoming_save_warehouse_name: item.lot_incoming_save_warehouse_name,
          lot_incoming_save_section_id: item.lot_incoming_save_section_id,
          lot_incoming_save_section_name: item.lot_incoming_save_section_name,
          row_type: 'O',
          update_type: 'N',
      })));

      setUpdateLotRows(LotData.map((item, index) => ({
          id: item.lot_incoming_item_lot_seq,
          upper_id: item.incoming_item_seq,
          lot_no: item.lot_incoming_item_lotno,
          lot_incoming_item_id: item.lot_incoming_item_id,
          lot_incoming_item_name: item.lot_incoming_item_name,
          lot_incoming_item_spec: item.lot_incoming_item_spec,
          lot_incoming_quality_exam_yn: item.lot_incoming_quality_exam_yn,
          lot_incoming_save_workplace_id: item.lot_incoming_save_workplace_id,
          lot_incoming_save_workplace_name: item.lot_incoming_save_workplace_name,
          lot_incoming_save_warehouse_id: item.lot_incoming_save_warehouse_id,
          lot_incoming_save_warehouse_name: item.lot_incoming_save_warehouse_name,
          lot_incoming_save_section_id: item.lot_incoming_save_section_id,
          lot_incoming_save_section_name: item.lot_incoming_save_section_name,
          row_type: 'O',
          update_type: 'N',
      })));

      setOriginLotRows(LotData.map((item, index) => ({
          id: item.lot_incoming_item_lot_seq,
          upper_id: item.incoming_item_seq,
          lot_no: item.lot_incoming_item_lotno,
          lot_incoming_item_id: item.lot_incoming_item_id,
          lot_incoming_item_name: item.lot_incoming_item_name,
          lot_incoming_item_spec: item.lot_incoming_item_spec,
          lot_incoming_quality_exam_yn: item.lot_incoming_quality_exam_yn,
          lot_incoming_save_workplace_id: item.lot_incoming_save_workplace_id,
          lot_incoming_save_workplace_name: item.lot_incoming_save_workplace_name,
          lot_incoming_save_warehouse_id: item.lot_incoming_save_warehouse_id,
          lot_incoming_save_warehouse_name: item.lot_incoming_save_warehouse_name,
          lot_incoming_save_section_id: item.lot_incoming_save_section_id,
          lot_incoming_save_section_name: item.lot_incoming_save_section_name,
          row_type: 'O',
          update_type: 'N',
      })));
    }
  })
  .catch((error) => {
      appStore.capture();
  });

  const t1 = performance.now();
  
  // 3) 정렬 (유니크된 건수만 정렬하므로 비용↓)
  const itemRows = Array.from(itemMap.values()).sort((a, b) => a.id - b.id);
  const userRows = Array.from(userMap.values()).sort((a, b) => a.id - b.id);
  const fileRows = Array.from(fileMap.values()); // 필요하면 정렬 추가

  const t2 = performance.now();
  
  // 4) setState — React 18에서는 자동 배칭됨
  //    origin* 과 현재* 가 동일 초기값이면 같은 배열을 넣어도 무방(절대 직접 mutate 금지!)
  setItemRows(itemRows);
  setOriginItemRows(itemRows);

  setUserRows(userRows);

  setFileRows(fileRows);
  setOriginFileRows(fileRows);

  // newFileID 계산 (map으로 돌리던 O(n) → 동일 O(n)이지만 한 번만)
  let maxFileId = 0;
  for (const f of fileRows) if (typeof f.id === 'number' && f.id > maxFileId) maxFileId = f.id;
  // setNewFileID && setNewFileID(maxFileId + 1); // 상태로 관리한다면

  const t3 = performance.now();
};

  const handleSetting = () => {
    setItemColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {itemDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {itemAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {itemDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'incoming_item_id', headerName: 'incoming_item_id', headerAlign: 'center', align:'center' },
      { field: 'incoming_item_name', headerName: '품목', width: 150, headerAlign: 'center', align:'left' },
      { field: 'incoming_item_spec', headerName: '규격', width: 190, headerAlign: 'center', align:'left' },
      { field: 'incoming_item_count', headerName: '입고수량', type: 'number', width: 90, headerAlign: 'center', align:'right', editable: true },
      { field: 'incoming_quality_exam_yn', headerName: '검사여부', type: 'singleSelect', width: 100, 
        valueOptions: () => qualityYnModalOption ?? [], valueFormmatter: ({  value }) => 
          qualityYnModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'incoming_save_workplace_id', headerName: 'incoming_save_workplace_id',width: 0, headerAlign: 'center'},
      { field: 'incoming_save_workplace_name', headerName: '사업장',width: 100, headerAlign: 'center', type: 'left'},
      { field: 'incoming_save_warehouse_id', headerName: 'incoming_save_warehouse_id', width: 0, headerAlign: 'center' },
      { field: 'incoming_save_warehouse_name', headerName: '창고', width: 100, headerAlign: 'center', align:'left' },
      { field: 'incoming_save_section_id', headerName: 'incoming_save_section_id',width: 0, headerAlign: 'center'},
      { field: 'incoming_save_section_name', headerName: '구역',width: 100, headerAlign: 'center', align:'left'},
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setLotColumns([
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'upper_id', headerName: 'upper_id', width: 0, headerAlign: 'center' },
      { field: 'lot_no', headerName: 'LotNo', width: 165, headerAlign: 'center', align:'center' },
      { field: 'lot_incoming_item_id', headerName: 'lot_incoming_item_id', headerAlign: 'center', align:'center' },
      { field: 'lot_incoming_item_name', headerName: '품목', width: 150, headerAlign: 'center', align:'left' },
      { field: 'lot_incoming_item_spec', headerName: '규격', width: 165, headerAlign: 'center', align:'left' },
      { field: 'lot_incoming_quality_exam_yn', headerName: '검사여부', type: 'singleSelect', width: 80, 
        valueOptions: () => qualityYnModalOption ?? [], valueFormmatter: ({  value }) => 
          qualityYnModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'lot_incoming_save_workplace_id', headerName: 'lot_incoming_save_workplace_id',width: 0, headerAlign: 'center'},
      { field: 'lot_incoming_save_workplace_name', headerName: '사업장',width: 110, headerAlign: 'center', type: 'left'},
      { field: 'lot_incoming_save_warehouse_id', headerName: 'lot_incoming_save_warehouse_id', width: 0, headerAlign: 'center' },
      { field: 'lot_incoming_save_warehouse_name', headerName: '창고', width: 110, headerAlign: 'center', align:'left' },
      { field: 'lot_incoming_save_section_id', headerName: 'lot_incoming_save_section_id',width: 0, headerAlign: 'center'},
      { field: 'lot_incoming_save_section_name', headerName: '구역',width: 110, headerAlign: 'center', align:'left'},
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setUserColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {userAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'incoming_user_id', headerName: 'incoming_user_id', width: 0, headerAlign: 'center' },
      { field: 'incoming_user_name', headerName: '담당자명', width: 120, headerAlign: 'center', align:'center' },
      { field: 'incoming_user_dept_name', headerName: '담당자부서', width: 120, headerAlign: 'center', align:'center' },
      { field: 'incoming_user_position_name', headerName: '담당자직위', width: 120, headerAlign: 'center', align:'center' },
      { field: 'incoming_user_type', headerName: '담당자유형', type: 'singleSelect', width: 120, 
        valueOptions: () => userTypeModalOption ?? [], valueFormmatter: ({  value }) => 
        userTypeModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'incoming_user_bigo', headerName: '비고', width: 350, headerAlign: 'center', align:'left', editable: true },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setFileColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {fileAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      {
        field: 'download',
        headerName: '다운로드',
        width: 90,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.row_type === "O")?
            <GridActionsCellItem icon={<DownloadIcon color={ "primary" } />} onClick={() => {fileDownloadClick(params)}} label="Download" />:<></>)
        ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'file_name_sever', headerName: 'file_name_sever', width: 0, headerAlign: 'center' },
      { field: 'file_size', headerName: 'file_size', width: 0, headerAlign: 'center' },
      { field: 'file_type', headerName: 'file_type', width: 0, headerAlign: 'center' },
      { field: 'file_extension', headerName: 'file_extension', width: 0, headerAlign: 'center' },
      { field: 'file_name', headerName: '파일명', width: 270, headerAlign: 'center' },
      { field: 'file_type_name', headerName: '유형', width: 110, headerAlign: 'center', align:'center' },
      { field: 'file_size_dp', headerName: '크기', width: 100, headerAlign: 'center', align:'right' },
      { field: 'reg_user_name', headerName: '등록자', width: 90, headerAlign: 'center', align:'center' },
      { field: 'reg_datetime', headerName: '등록일시', width: 160, headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);
    
    setItemColumnVisibilityModel({
      id: false,
      actions: updateFlag,
      incoming_item_id: false,
      incoming_item_name: true,
      incoming_item_spec: true,
      incoming_item_count: true,
      incoming_quality_exam_yn: false,
      incoming_save_workplace_id: false,
      incoming_save_workplace_name: true,
      incoming_save_warehouse_id: false,
      incoming_save_warehouse_name: true,
      incoming_save_section_id: false,
      incoming_save_section_name: true,
      row_type: false,
      update_type: false
    })

    setLotColumnVisibilityModel ({
      id: false,
      upper_id: false,
      lot_no: true,
      lot_incoming_item_id: false,
      lot_incoming_item_name: true,
      lot_incoming_item_spec: true,
      lot_incoming_quality_exam_yn: false,
      lot_incoming_save_workplace_id: false,
      lot_incoming_save_workplace_name: true,
      lot_incoming_save_warehouse_id: false,
      lot_incoming_save_warehouse_name: true,
      lot_incoming_save_section_id: false,
      lot_incoming_save_section_name: true,
      row_type: false,
      update_type: false
    })

    setUserColumnVisibilityModel({
      id: false,
      actions: updateFlag,
      incoming_user_id: false,
      incoming_user_name: true,
      incoming_user_dept_name: true,
      incoming_user_position_name: true,
      incoming_user_type: true,
      incoming_user_bigo: true,
      row_type: false,
      update_type: false
    });

    setFileColumnVisibilityModel({
      id: false,
      file_name_sever: false,
      file_size: false,
      file_type: false,
      file_extension: false,
      file_name: true,
      file_type_name: true,
      file_size_dp: true,
      reg_user_name: true,
      reg_datetime: true,
      actions: updateFlag,
      download: true,
      row_type: false,
      update_type: false
    });
  }

  const [itemColumnVisibilityModel, setItemColumnVisibilityModel] = useState({
    id: false,
    actions: updateFlag,
    incoming_item_id: false,
    incoming_item_name: true,
    incoming_item_spec: true,
    incoming_item_count: true,
    incoming_quality_exam_yn: true,
    incoming_save_workplace_id: false,
    incoming_save_workplace_name: true,
    incoming_save_warehouse_id: false,
    incoming_save_warehouse_name: true,
    incoming_save_section_id: false,
    incoming_save_section_name: true,
    row_type: false,
    update_type: false
  });

  const [lotColumnVisibilityModel, setLotColumnVisibilityModel] = useState({
    id: false,
    upper_id: false,
    lot_no: true,
    lot_incoming_item_id: false,
    lot_incoming_item_name: true,
    lot_incoming_item_spec: true,
    lot_incoming_quality_exam_yn: true,
    lot_incoming_save_workplace_id: false,
    lot_incoming_save_workplace_name: true,
    lot_incoming_save_warehouse_id: false,
    lot_incoming_save_warehouse_name: true,
    lot_incoming_save_section_id: false,
    lot_incoming_save_section_name: true,
    row_type: false,
    update_type: false
  });

  const [userColumnVisibilityModel, setUserColumnVisibilityModel] = useState({
    id: false,
    actions: updateFlag,
    incoming_user_id: false,
    incoming_user_name: true,
    incoming_user_dept_name: true,
    incoming_user_position_name: true,
    incoming_user_type: true,
    incoming_user_bigo: true,
    row_type: false,
    update_type: false
  });

  const [fileColumnVisibilityModel, setFileColumnVisibilityModel] = useState({
    id: false,
    file_name_sever: false,
    file_size: false,
    file_type: false,
    file_extension: false,
    file_name: true,
    file_type_name: true,
    file_size_dp: true,
    reg_user_name: true,
    reg_datetime: true,
    actions: updateFlag,
    download: true,
    row_type: false,
    update_type: false
  });

  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    realFiles = [];
    tmpRealFiles = [];
    handleSetting();
    setTabPanelHeight(tabPanelRef.current.clientHeight);
  }, []);

  useEffect(() => {
    if(inputs.incoming_number !== ''){

      axios.get('/api/Common/LotNoOrderStartNumber',
        {
          params : {
            lot_number: inputs.incoming_number
          }
        },
        { withCredentials: true }
      )
      .then((response) => { 
        setLotOrderStartNumber(response.data);
      })
      .catch((error) => {
          console.log(error);
      });

    }
  }, [inputs.incoming_number]);

  useEffect(() => {
    handleInitSelect();
  }, [originRows]);
  
  useEffect(() => {
    let ADD_YN= 'Y'
    for(let i=0; i<itemRows.length; i++){
      if(itemRows[i].row_type === 'A' && itemRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }

    if(ADD_YN === 'Y' && updateFlag){
      setItemRows((itemRows) => [...itemRows, { 
        id: Number(appStore.getMaxListID(itemRows))+1,
        incoming_item_id: '',
        incoming_item_name: '',
        incoming_item_spec: '',
        incoming_item_count: '',
        incoming_quality_exam_yn: 'N',
        incoming_save_workplace_id: null,
        incoming_save_workplace_name: '',
        incoming_save_warehouse_id: null,
        incoming_save_warehouse_name: '',
        incoming_save_section_id: null,
        incoming_save_section_name: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [itemRows]);
  
  useEffect(() => {
    // userRows가 변경될 때 마지막 Row ADD가 없으면 추가시킨다.
    let ADD_YN= 'Y'
    for(let i=0; i<userRows.length; i++){
      if(userRows[i].row_type === 'A' && (userRows[i].update_type === 'N')){
        ADD_YN = "N"; //마지막 Row update_type = 'N'으로 N유지
      }
    }

    if(ADD_YN === 'Y' && updateFlag){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        incoming_user_id: '',
        incoming_user_name: '',
        incoming_user_dept_name: '',
        incoming_user_position_name: '',
        incoming_user_type: '',
        incoming_user_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [userRows]);

  useEffect(() => {
    var array = [];
    for(var i=0; i<originFileRows.length; i++){
      var tmp_id = originFileRows[i].id;
      var tmp_file_name_sever = originFileRows[i].file_name_sever;
      var tmp_file_name = originFileRows[i].file_name;
      var tmp_file_size = originFileRows[i].file_size;
      var tmp_file_size_dp = originFileRows[i].file_size_dp;
      var tmp_file_type = originFileRows[i].file_type;
      var tmp_file_type_name  = originFileRows[i].file_type_name;
      var tmp_file_extension = originFileRows[i].file_extension;
      var tmp_file_reg_user_name = originFileRows[i].reg_user_name;
      var tmp_file_reg_datetime = originFileRows[i].reg_datetime;

      var tmpYN = 'N'
      for(var j=0; j<fileRows.length; j++){
        //origin에는 있고 file에는 없으면 -> O / D
        if(fileRows[j].id === originFileRows[i].id && fileRows[j].file_name_sever === originFileRows[i].file_name_sever && fileRows[j].reg_user_name === originFileRows[i].reg_user_name && fileRows[j].reg_datetime === originFileRows[i].reg_datetime){
          tmpYN = 'Y'
        }
      }

      if(tmpYN === 'N'){
        array.push({
          id: tmp_id,
          file_name_sever: tmp_file_name_sever,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_type_name: tmp_file_type_name,
          file_name: tmp_file_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: tmp_file_reg_user_name,
          reg_datetime: tmp_file_reg_datetime,
          row_type:'O',
          update_type: 'D'
        })
      }
    }

    for(var i=0; i<fileRows.length; i++){
      var tmp_id = fileRows[i].id;
      var tmp_file_name_sever = fileRows[i].file_name_sever;
      var tmp_file_size = fileRows[i].file_size;
      var tmp_file_type = fileRows[i].file_type;
      var tmp_file_extension = fileRows[i].file_extension;
      var tmp_file_name = fileRows[i].file_name;
      var tmp_file_type_name = fileRows[i].file_type_name;
      var tmp_file_size_dp = fileRows[i].file_size_dp;
      var tmp_reg_user_name = fileRows[i].reg_user_name;
      var tmp_reg_datetime = fileRows[i].reg_datetime;
      var tmp_row_type = fileRows[i].row_type;
      var tmp_update_type = fileRows[i].update_type;
      
      var tmpYN = 'N'
      for(var j=0; j<originFileRows.length; j++){
        if(originFileRows[j].id === fileRows[i].id && originFileRows[j].file_name_sever === fileRows[i].file_name_sever && originFileRows[j].reg_user_name === fileRows[i].reg_user_name && originFileRows[j].reg_datetime === fileRows[i].reg_datetime){
          tmpYN = 'Y'
        }
      }

      if(tmpYN === 'N'){
        if(tmp_row_type !== 'A' || tmp_update_type !== 'N'){ // 신규Row(A, N)는 제외함.
          array.push({
            id: tmp_id,
            file_name_sever: tmp_file_name_sever,
            file_size: tmp_file_size,
            file_type: tmp_file_type,
            file_extension: tmp_file_extension,
            file_type_name: tmp_file_type_name,
            file_name: tmp_file_name,
            file_size_dp: tmp_file_size_dp,
            reg_user_name: tmp_file_reg_user_name,
            reg_datetime: tmp_file_reg_datetime,
            row_type:'A',
            update_type: 'U'
          })
        }
      }
    }
    setUpdateFileRows(array);
    
    let ADD_YN = 'Y'
    for(let i=0; i<fileRows.length; i++){
      if(fileRows[i].row_type === 'A' && fileRows[i].update_type === 'N' && i === (fileRows.length-1)){
        ADD_YN = 'N'
      }else if(fileRows[i].row_type === 'A' && fileRows[i].update_type === 'N'){
        setFileRows((fileRows) => fileRows.filter((data) => data.id !== fileRows[i].id));
        ADD_YN = 'N'
      }
    }
    
    if(ADD_YN === 'Y' && updateFlag){
      newFileID = Number(newFileID) + 1;
      setFileRows((fileRows) => [...fileRows, { 
        id: Number(newFileID),
        file_name_sever: '',
        file_size: 0,
        file_type: '',
        file_extension: '',
        file_name: '',
        file_type_name: '',
        file_size_dp: '',
        reg_user_name: '',
        reg_datetime: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [fileRows]);

  const onClick = (e)=>{ // inputs 데이터 품목 text 클릭시

    setSelectModalTitle('입고처 목록')
    setSelectPartnerModalOpen(true);
    
  };

  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const onDateChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
    createLotRow(itemRows, [{id:0}], 'A', e.target.value); // 입고정보 날짜 변경 시 lot 임시번호 갱신
  };

  const onHypenChange = (e)=>{
    const {name, value} = e.target;
    var hyphen_data = ''
    if(e.target.name === 'incoming_partner_manager_phone'){ // 전화번호인 경우
        hyphen_data = e.target.value
        .replace(/[^0-9.]/g, "")
        .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
        .replace(/(-{1,2})$/g, "");
    }
    const nextInputs = {
        ...inputs,
        [name]: hyphen_data, 
    };
    setInputs(nextInputs);
  };

  const handleTabID = (event, newTabID) => {
    setTabID(newTabID);
  };

  const processItemRowUpdate = (newRow, oldRow) => {
    //입고 품목 Rows Update
    if(newRow.incoming_item_count > 99999){
      return
    }

    // 날짜형식 fomat 맞춰주기
    const newUpdateDataArray = { 
        ...newRow
        , update_type: 'U' }; // 값 변경이 있는 경우
    const newNoDataArray = { 
        ...newRow
        , update_type: 'N' }; // 값 변경이 없는 경우
    
    if(newRow.incoming_item_id !== oldRow.incoming_item_id || newRow.incoming_item_name !== oldRow.incoming_item_name || newRow.incoming_item_count !== oldRow.incoming_item_count || newRow.incoming_quality_exam_yn !== oldRow.incoming_quality_exam_yn || newRow.incoming_save_workplace_id !== oldRow.incoming_save_workplace_id || newRow.incoming_save_warehouse_id !== oldRow.incoming_save_warehouse_id || newRow.incoming_save_section_id !== oldRow.incoming_save_section_id){
      // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
      var row_incoming_item_id = '';
      var row_incoming_item_name = '';
      var row_incoming_item_spec = '';
      var row_incoming_item_count = '';
      var row_incoming_quality_exam_yn = 'N';
      var row_incoming_save_workplace_id = null;
      var row_incoming_save_workplace_name = '';
      var row_incoming_save_warehouse_id = null;
      var row_incoming_save_warehouse_name = '';
      var row_incoming_save_section_id = null;
      var row_incoming_save_section_name = '';

      if(String(newRow.row_type) === "A"){
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if(newRow.incoming_item_id !== '' || newRow.incoming_item_name !== '' || newRow.incoming_item_spec !== '' || newRow.incoming_item_count !== '' || newRow.incoming_quality_exam_yn !== 'N' 
          || newRow.incoming_save_workplace_id !== null || newRow.incoming_save_warehouse_id !== null || newRow.incoming_save_section_id !== null){
          row_incoming_item_id = newRow.incoming_item_id;
          row_incoming_item_name = newRow.incoming_item_name;
          row_incoming_item_spec = newRow.incoming_item_spec;
          row_incoming_item_count = newRow.incoming_item_count;
          row_incoming_quality_exam_yn = newRow.incoming_quality_exam_yn;
          row_incoming_save_workplace_id = newRow.incoming_save_workplace_id;
          row_incoming_save_workplace_name = newRow.incoming_save_workplace_name;
          row_incoming_save_warehouse_id = newRow.incoming_save_warehouse_id;
          row_incoming_save_warehouse_name = newRow.incoming_save_warehouse_name;
          row_incoming_save_section_id = newRow.incoming_save_section_id;
          row_incoming_save_section_name = newRow.incoming_save_section_name;
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        //console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        itemRows.map((data) => data.id === newRow.id 
          && (data.incoming_item_id !== newRow.incoming_item_id || data.incoming_item_name !== newRow.incoming_item_name 
            || data.incoming_item_spec !== newRow.incoming_item_spec || data.incoming_item_count !== newRow.incoming_item_count || data.incoming_quality_exam_yn !== newRow.incoming_quality_exam_yn
            || data.incoming_save_workplace_id !== newRow.incoming_save_workplace_id || data.incoming_save_warehouse_id !== newRow.incoming_save_warehouse_id
            || data.incoming_save_section_id !== newRow.incoming_save_section_id)?
          (
            row_incoming_item_id = data.incoming_item_id,
            row_incoming_item_name = data.incoming_item_name,
            row_incoming_item_spec = data.incoming_item_spec,
            row_incoming_item_count = data.incoming_item_count,
            row_incoming_quality_exam_yn = data.incoming_quality_exam_yn,
            row_incoming_save_workplace_id = data.incoming_save_workplace_id,
            row_incoming_save_workplace_name = data.incoming_save_workplace_name,
            row_incoming_save_warehouse_id = data.incoming_save_warehouse_id,
            row_incoming_save_warehouse_name = data.incoming_save_warehouse_name,
            row_incoming_save_section_id = data.incoming_save_section_id,
            row_incoming_save_section_name = data.incoming_save_section_name
          ):""
        )
      }
      
      if(row_incoming_item_id === '' && row_incoming_item_name === '' && row_incoming_item_spec === '' && row_incoming_item_count === '' 
        && row_incoming_quality_exam_yn === 'N' && row_incoming_save_workplace_id === null && row_incoming_save_warehouse_id === null && row_incoming_save_section_id === null){
        // 1. 값이 수정되지 않은 경우.
        if(updateItemRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          //console.log('[updateRows 원복] ' + updateItemRows.length);
          setUpdateItemRows(updateItemRows.filter((data) => data.id !== newRow.id));
          setItemRows(itemRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
          createLotRow(itemRows, newNoDataArray, 'A', inputs.incoming_date)
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updateItemRows.length; i++) {
          if(updateItemRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updateItemRows.length);
          setUpdateItemRows(updateItemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setItemRows(itemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          createLotRow(itemRows, newUpdateDataArray, 'A', inputs.incoming_date)
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updateItemRows.length);
          setUpdateItemRows(prevRows => [...prevRows, newUpdateDataArray]);
          setItemRows(itemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          createLotRow(itemRows, newUpdateDataArray, 'A', inputs.incoming_date)
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  // item row 업데이트와 동시에 lot row 생성 (배치 방식)
  const createLotRow = (tempItemRow, tempNewUpdateData, tempType, changeDate, startNumber = '0') => {
    if (tempType === 'D') {
      // 삭제: 해당 upper_id 행만 제거
      setLotRows(prev => prev.filter(r => r.upper_id !== tempNewUpdateData.id));
      setUpdateLotRows(prev => prev.filter(r => r.upper_id !== tempNewUpdateData.id));
      return;
    }

    // 일반 추가/업데이트: 대상 upper_id 행만 싹 지우고, 새로 만든 배열을 한 번에 합침
    const now_lot_date_count = lotNoStartNumber;
    const now_lot_order_count = lotOrderStartNumber;

    // 추가될 개수(수량). (빈 값/0이면 0개)
    const lotsToAdd =
      (tempNewUpdateData.incoming_item_id !== '' && tempNewUpdateData.incoming_item_id !== 0)
        ? Number(tempNewUpdateData.incoming_item_count || 0)
        : 0;

    // lotRows 갱신
    setLotRows(prev => {
      const kept = prev.filter(r => r.upper_id !== tempNewUpdateData.id);
      let nextId = Number(appStore.getMaxListID(kept)) + 1;
      const newRows = settingLotRows(
        tempNewUpdateData,
        now_lot_date_count,
        now_lot_order_count,
        changeDate,
        nextId
      );
      return [...kept, ...newRows];
    });

    // updateLotRows 갱신
    setUpdateLotRows(prev => {
      const kept = prev.filter(r => r.upper_id !== tempNewUpdateData.id);
      let nextId = Number(appStore.getMaxListID(kept)) + 1;
      const newRows = settingLotRows(
        tempNewUpdateData,
        now_lot_date_count,
        now_lot_order_count,
        changeDate,
        nextId
      );
      return [...kept, ...newRows];
    });

    // order 시퀀스는 생성한 개수만큼 증가
    if (lotsToAdd > 0) {
      setLotOrderStartNumber(now_lot_order_count + lotsToAdd);
    }
  };

  // lot grid 데이터 "배열로 만들어" 리턴 (setState 안 함)
  const settingLotRows = (insertData, now_lot_date_count, now_lot_order_count, changeDate, startId) => {
    const rows = [];

    const incoming_item_id = insertData.incoming_item_id;
    const incoming_item_name = insertData.incoming_item_name;
    const incoming_item_spec = insertData.incoming_item_spec;
    const incoming_item_count = Number(insertData.incoming_item_count || 0);
    // 업데이트 버전 로직 맞춰 검사여부는 'N' 고정
    const incoming_quality_exam_yn = 'N';
    const incoming_save_workplace_id = insertData.incoming_save_workplace_id;
    const incoming_save_workplace_name = insertData.incoming_save_workplace_name;
    const incoming_save_warehouse_id = insertData.incoming_save_warehouse_id;
    const incoming_save_warehouse_name = insertData.incoming_save_warehouse_name;
    const incoming_save_section_id = insertData.incoming_save_section_id;
    const incoming_save_section_name = insertData.incoming_save_section_name;
    const row_type = insertData.row_type;
    const update_type = insertData.update_type;

    // 품목 미선택(빈 문자열/0) 또는 수량 0 이하면 아무것도 생성하지 않음
    if (incoming_item_id === '' || incoming_item_id === 0 || incoming_item_count <= 0) {
      return rows;
    }

    const tempDate = String(now_lot_date_count).padStart(3, '0');

    for (let idx = 0; idx < incoming_item_count; idx++) {
      const tempNo = String(Number(now_lot_order_count) + idx).padStart(5, '0');
      const tempLotNo = 'I' + Moment(changeDate).format('YYMMDD') + tempDate + '-' + tempNo;

      rows.push({
        id: startId + idx,
        upper_id: insertData.id,
        lot_no: tempLotNo,
        lot_incoming_item_id: incoming_item_id,
        lot_incoming_item_name: incoming_item_name,
        lot_incoming_item_spec: incoming_item_spec,
        lot_incoming_quality_exam_yn: incoming_quality_exam_yn, // 'N'
        lot_incoming_save_workplace_id: incoming_save_workplace_id,
        lot_incoming_save_workplace_name: incoming_save_workplace_name,
        lot_incoming_save_warehouse_id: incoming_save_warehouse_id,
        lot_incoming_save_warehouse_name: incoming_save_warehouse_name,
        lot_incoming_save_section_id: incoming_save_section_id,
        lot_incoming_save_section_name: incoming_save_section_name,
        row_type: row_type,
        update_type: update_type
      });
    }

    return rows;
  };

  const processLotRowUpdate = (newRow, oldRow) => {
    //입고 품목 Rows Update

    // 날짜형식 fomat 맞춰주기
    const newUpdateDataArray = { 
        ...newRow
        , update_type: 'U' }; // 값 변경이 있는 경우
    const newNoDataArray = { 
        ...newRow
        , update_type: 'N' }; // 값 변경이 없는 경우
    
    if(newRow.lot_incoming_save_workplace_id !== oldRow.lot_incoming_save_workplace_id || newRow.lot_incoming_save_warehouse_id !== oldRow.lot_incoming_save_warehouse_id || newRow.lot_incoming_save_section_id !== oldRow.lot_incoming_save_section_id){
      // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
      var row_upper_id = 0;
      var row_lot_incoming_item_id = '';
      var row_lot_incoming_item_name = '';
      var row_lot_incoming_item_spec = '';
      var row_lot_incoming_quality_exam_yn = 'N';
      var row_lot_incoming_save_workplace_id = null
      var row_lot_incoming_save_workplace_name = '';
      var row_lot_incoming_save_warehouse_id = null;
      var row_lot_incoming_save_warehouse_name = '';
      var row_lot_incoming_save_section_id = null;
      var row_lot_incoming_save_section_name = '';

      if(String(newRow.row_type) === "A"){
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if(newRow.lot_incoming_save_workplace_id !== null|| newRow.lot_incoming_save_workplace_name !== ''
          || newRow.lot_incoming_save_warehouse_id !== null || newRow.lot_incoming_save_warehouse_name !== ''
          || newRow.lot_incoming_save_section_id !== null || newRow.lot_incoming_save_section_name !== ''){
          row_upper_id = newRow.row_upper_id;
          row_lot_incoming_item_id = newRow.lot_incoming_item_id;
          row_lot_incoming_item_name = newRow.lot_incoming_item_name;
          row_lot_incoming_item_spec = newRow.lot_incoming_item_spec;
          row_lot_incoming_quality_exam_yn = newRow.lot_incoming_quality_exam_yn;
          row_lot_incoming_save_workplace_id = newRow.lot_incoming_save_workplace_id;
          row_lot_incoming_save_workplace_name = newRow.lot_incoming_save_workplace_name;
          row_lot_incoming_save_warehouse_id = newRow.lot_incoming_save_warehouse_id;
          row_lot_incoming_save_warehouse_name = newRow.lot_incoming_save_warehouse_name;
          row_lot_incoming_save_section_id = newRow.lot_incoming_save_section_id;
          row_lot_incoming_save_section_name = newRow.lot_incoming_save_section_name;
        
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        //console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        lotRows.map((data) => data.id === newRow.id 
          && (data.lot_incoming_save_workplace_id !== newRow.lot_incoming_save_workplace_id
            || data.lot_incoming_save_warehouse_id !== newRow.lot_incoming_save_warehouse_id
            || data.lot_incoming_save_section_id !== newRow.lot_incoming_save_section_id )?
          (
            row_upper_id = data.row_upper_id,
            row_lot_incoming_item_id = data.lot_incoming_item_id,
            row_lot_incoming_item_name = data.lot_incoming_item_name,
            row_lot_incoming_item_spec = data.lot_incoming_item_spec,
            row_lot_incoming_quality_exam_yn = data.lot_incoming_quality_exam_yn,
            row_lot_incoming_save_workplace_id = data.lot_incoming_save_workplace_id,
            row_lot_incoming_save_workplace_name = data.lot_incoming_save_workplace_name,
            row_lot_incoming_save_warehouse_id = data.lot_incoming_save_warehouse_id,
            row_lot_incoming_save_warehouse_name = data.lot_incoming_save_warehouse_name,
            row_lot_incoming_save_section_id = data.lot_incoming_save_section_id,
            row_lot_incoming_save_section_name = data.lot_incoming_save_section_name
          ):""
        )
      }
      
      if(row_lot_incoming_save_workplace_id === null && row_lot_incoming_save_warehouse_id === null && row_lot_incoming_save_section_id === null){
        // 1. 값이 수정되지 않은 경우.
        if(updateLotRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          //console.log('[updateRows 원복] ' + updateLotRows.length);
          setUpdateLotRows(updateLotRows.filter((data) => data.id !== newRow.id));
          setLotRows(lotRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updateLotRows.length; i++) {
          if(updateLotRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updateLotRows.length);
          setUpdateLotRows(updateLotRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setLotRows(lotRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updateLotRows.length);
          setUpdateLotRows(prevRows => [...prevRows, newUpdateDataArray]);
          setLotRows(lotRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const processUserRowUpdate = (newRow, oldRow) => {
    //자원 담당자 Rows Update
    const newUpdateDataArray = { ...newRow, update_type: 'U' }; // 값 변경이 있는 경우
    const newNoDataArray = { ...newRow, update_type: 'N' }; // 값 변경이 없는 경우
    
    if(oldRow.incoming_user_id !== newRow.incoming_user_id || oldRow.incoming_user_type !== newRow.incoming_user_type || oldRow.incoming_user_bigo !== newRow.incoming_user_bigo){
      // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
      var row_incoming_user_id = '';
      var row_incoming_user_name = '';
      var row_incoming_user_type = '';
      var row_incoming_user_bigo = '';
      
      if(String(newRow.row_type) === "A"){
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if(newRow.incoming_user_id !== '' || newRow.incoming_user_name !== '' || (newRow.incoming_user_type !== 0 && newRow.incoming_user_type !== '') || newRow.incoming_user_bigo !== '' ){
          row_incoming_user_id = newRow.incoming_user_id;
          row_incoming_user_name = newRow.incoming_user_name;
          row_incoming_user_type = newRow.incoming_user_type;
          row_incoming_user_bigo = newRow.incoming_user_bigo;
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        //console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        userRows.map((data) => data.id === newRow.id 
          && (data.incoming_user_id !== newRow.incoming_user_id || data.incoming_user_name !== newRow.incoming_user_name || data.incoming_user_type !== newRow.incoming_user_type || data.incoming_user_bigo !== newRow.incoming_user_bigo )?
          (
            row_incoming_user_id = data.incoming_user_id,
            row_incoming_user_name = data.incoming_user_name,
            row_incoming_user_type = data.incoming_user_type,
            row_incoming_user_bigo = data.incoming_user_bigo
          ):""
        )
      }
      
      if(row_incoming_user_id === '' && row_incoming_user_name === '' && row_incoming_user_bigo === '' && (row_incoming_user_type === '' || row_incoming_user_type === null)){
        // 1. 값이 수정되지 않은 경우.
        if(updateUserRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          //console.log('[updateRows 원복] ' + updateUserRows.length);
          setUpdateUserRows(updateUserRows.filter((data) => data.id !== newRow.id));
          setUserRows(userRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updateUserRows.length; i++) {
          if(updateUserRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updateUserRows.length);
          setUpdateUserRows(updateUserRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updateUserRows.length);
          setUpdateUserRows(prevRows => [...prevRows, newUpdateDataArray]);
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const itemAddClick = (object) => {
    //입고 품목 추가 버튼
    if(object.row.row_type !== 'A' || object.row.update_type !== 'N'){
      setItemRows((itemRows) => [...itemRows, { 
        id: Number(appStore.getMaxListID(itemRows))+1,
        incoming_item_id: '',
        incoming_item_name: '',
        incoming_item_spec: '',
        incoming_item_count: '',
        incoming_quality_exam_yn: 'N',
        incoming_save_workplace_id: null,
        incoming_save_workplace_name: '',
        incoming_save_warehouse_id: null,
        incoming_save_warehouse_name: '',
        incoming_save_section_id: null,
        incoming_save_section_name: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }else{
      setSelectModalTitle('품목 목록')
      setSelectItemModalOpen(true);
      setSelectItemData({
        id: object.row.id,
        incoming_item_id: object.row.incoming_item_id,
        incoming_item_name: object.row.incoming_item_name,
        incoming_item_spec: object.row.incoming_item_spec,
        incoming_item_count: object.row.incoming_item_count,
        incoming_quality_exam_yn: object.row.incoming_quality_exam_yn,
        incoming_save_workplace_id: object.row.incoming_save_workplace_id,
        incoming_save_workplace_name: object.row.incoming_save_workplace_name,
        incoming_save_warehouse_id: object.row.incoming_save_warehouse_id,
        incoming_save_warehouse_name: object.row.incoming_save_warehouse_name,
        incoming_save_section_id: object.row.incoming_save_section_id,
        incoming_save_section_name: object.row.incoming_save_section_name,
        row_type: object.row.row_type,
        update_type: object.row.update_type,
      })
    }
  };

  const itemDeleteClick = (object) => {
    //입고 품목 삭제 버튼
    if(object.row.row_type === 'O'){
      setUpdateItemRows(prevRows => [...prevRows, {
        id: object.row.id,
        incoming_item_id: object.row.incoming_item_id,
        incoming_item_name: object.row.incoming_item_name,
        incoming_item_spec: object.row.incoming_item_spec,
        incoming_item_count: object.row.incoming_item_count,
        incoming_quality_exam_yn: object.row.incoming_quality_exam_yn,
        incoming_save_workplace_id: object.row.incoming_save_workplace_id,
        incoming_save_workplace_name: object.row.incoming_save_workplace_name,
        incoming_save_warehouse_id: object.row.incoming_save_warehouse_id,
        incoming_save_warehouse_name: object.row.incoming_save_warehouse_name,
        incoming_save_section_id: object.row.incoming_save_section_id,
        incoming_save_section_name: object.row.incoming_save_section_name,
        row_type:'O',
        update_type: 'D'
      }]);
    }else{
      setUpdateItemRows((updateItemRows) => updateItemRows.filter((data) => data.id !== object.row.id));
    }
    setItemRows((itemRows) => itemRows.filter((data) => data.id !== object.row.id));
    createLotRow(itemRows,object.row,'D', inputs.changeDate)
  };

  const userAddClick = (object) => {
    //입고 담당자 추가 버튼
    if(object.row.row_type !== 'A' || object.row.update_type !== 'N'){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        incoming_user_id: '',
        incoming_user_name: '',
        incoming_user_dept_name: '',
        incoming_user_position_name: '',
        incoming_user_type: '',
        incoming_user_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }else{
      setSelectModalTitle('사용자 목록')
      setSelectUserModalOpen(true);
      setSelectUserData({
        id: object.row.id,
        incoming_user_id: object.row.incoming_user_id,
        incoming_user_name: object.row.incoming_user_name,
        incoming_user_dept_name: object.row.incoming_user_dept_name,
        incoming_user_position_name: object.row.incoming_user_position_name,
        incoming_user_type: object.row.incoming_user_type,
        incoming_user_bigo: object.row.incoming_user_bigo,
        row_type: object.row.row_type,
        update_type: object.row.update_type
      })
    }
  };

  const userDeleteClick = (object) => {
    //입고 담당자 삭제 버튼
    if(object.row.row_type === 'O'){
      setUpdateUserRows(prevRows => [...prevRows, {
        id: object.row.id,
        incoming_user_id: object.row.incoming_user_id,
        incoming_user_name: object.row.incoming_user_name,
        incoming_user_dept_name: object.row.incoming_user_dept_name,
        incoming_user_position_name: object.row.incoming_user_position_name,
        incoming_user_type: object.row.incoming_user_type,
        incoming_user_bigo: object.row.incoming_user_bigo,
        row_type:'O',
        update_type: 'D'
      }]);
    }else{
      setUpdateUserRows((updateUserRows) => updateUserRows.filter((data) => data.id !== object.row.id));
    }
    setUserRows((userRows) => userRows.filter((data) => data.id !== object.row.id));
  };

  const fileAddClick = (object) => {
    const input=document.createElement('input');
    input.id=object.row.id;
    input.type="file";
    input.multiple = true;
    input.click();
    input.onchange = () => {
      tmpRealFiles = []; // 수정은 초기화용과 업로드용을 따로 둔다.
      for(var i=0; i<input.files.length; i++){
        realFiles.push(input.files[i]);
        tmpRealFiles.push(input.files[i]);
      }

      var array = [];
      for(var i=0; i<tmpRealFiles.length; i++){
        var tmp_sever_file_name = tmpRealFiles[i].name;
        var tmp_file_name = tmpRealFiles[i].name;
        var tmp_file_size = tmpRealFiles[i].size;
        var tmp_file_size_dp = appStore.convertFileSize(tmpRealFiles[i].size);
        var tmp_file_type = tmpRealFiles[i].type;
        var tmp_file_type_name  = appStore.convertFileTypeName(tmpRealFiles[i].type);
        var tmp_file_extension = tmp_sever_file_name.substring(tmp_sever_file_name.lastIndexOf('.')+1, tmp_sever_file_name.length);
        
        newFileID = Number(newFileID) + 1;
        array.push({
          id: Number(newFileID),
          file_name_sever: tmp_sever_file_name,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_type_name: tmp_file_type_name,
          file_name: tmp_file_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: '',
          reg_datetime: '',
          row_type:'A',
          update_type: 'U'
        });
      }
      setFileRows((fileRows) => [...fileRows, ...array]);
    };
  };

  const fileDeleteClick = (object) => {
    //파일 삭제 버튼
    for(let i = 0; i < realFiles.length; i++) {
      if (realFiles[i].name === object.row.file_name_sever) {
        realFiles.splice(i, 1);
        break;
      }
    }

    if(object.row.row_type === 'O'){
      setUpdateFileRows(prevRows => prevRows.some(r => r.id === object.row.id && r.update_type === 'D') ? prevRows : [...prevRows, { 
        id: object.row.id,
        file_name_sever: object.row.incoming_file_name_sever,
        file_size: object.row.incoming_file_size,
        file_type: object.row.incoming_file_type,
        file_extension: object.row.incoming_file_extension,
        file_name: object.row.incoming_file_name,
        file_type_name: object.row.incoming_file_type_name,
        file_size_dp: object.row.incoming_file_size_dp,
        reg_user_name: object.row.incoming_file_user_name,
        reg_datetime: Moment(object.row.incoming_file_user_datetime).format('YYYY-MM-DD HH:mm:ss'),
        row_type: 'O',
        update_type: 'D'
       }]);
    }else{
      setUpdateFileRows((updateFileRows) => updateFileRows.filter((data) => data.id !== object.row.id));
    }
    
    setFileRows((fileRows) => fileRows.filter((data) => data.id !== object.row.id));
  };

  const fileDownloadClick = (object) => {
    //파일 다운로드
    axios.post('/api/SaveCommon/FileDownload', new URLSearchParams({
      fileName: object.row.file_name,
      fileNameSever: object.row.file_name_sever
    }),
    { withCredentials: true, responseType: 'blob' })
    .then(function (response) {
        if(response.status === 200){
          const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", object.row.file_name);
					document.body.appendChild(link);
					link.click();
        }else{
          appStore.capture();
        }
    })
    .catch(function (error) {
        appStore.capture();
        console.log("네트워크 실패", error);
    })
  };

  const handleIncomingUpdate = (event) => {
    // 입고 취소 // 혹은 원복
    var status_str = ''
    var change_status = ''
    if(originRows[0].incoming_status === 'S'){ // 입고취소
      status_str = '취소'
      change_status = 'D'
    } else { // 입고원복
      status_str = '원복'
      change_status = 'S'
    }

    Swal.fire({
      title: '입고번호 '+originRows[0].incoming_number+' ' + status_str,
      text: '입고를 '+ status_str +' 하시겠습니까?',
      showCancelButton: true,
      confirmButtonText: '예', 
      cancelButtonText: '아니오',
      confirmButtonColor: '#0067a3',
      cancelButtonColor: '#d33',
    }).then(result => {
      if (result.isConfirmed) {
        
        if(change_status === 'D' && originRows[0].incoming_use_cnt !== 0){ // 입고 완료된 건은 발주 취소 안됨
          Swal.fire({
            title: '입고 취소 불가',
            text: '사용된 품목이 있는 입고는 취소할 수 없습니다.',
            confirmButtonText: '확인',
            timer: 5000,
            timerProgressBar: true
          });
        } else {
          if (appStore.loading) return;
          appStore.setLoading(true);

          axios.post('/api/p/Incoming/Update', new URLSearchParams({
              cancel_incoming_id: originRows[0].incoming_id,
              change_status: change_status
          }),
          { withCredentials: true })
          .then(function (response) {
              if(response.status === 200){
                  Swal.fire({
                    title: '입고번호 '+originRows[0].incoming_number+' ' + status_str + ' 완료',
                    text: '정상적으로 입고가 '+status_str+' 되었습니다.',
                    confirmButtonText: '확인',
                    timer: 5000,
                    timerProgressBar: true
                  }).then((result) => {
                    handleView();
                  });
              }else{
                  appStore.capture();
              }
          })
          .catch(function (error) {
            // 오류발생시 실행
            appStore.capture();
            console.log("네트워크 실패", error);
          })
          .finally(() => {
            appStore.setLoading(false); 
          });
        }
      }
    })
  }

  const handleOnCellClick = (params) => {
    if(params.field === 'incoming_item_name' || params.field === 'incoming_item_spec' 
      || params.field === 'incoming_save_workplace_name' || params.field === 'incoming_save_warehouse_name' || params.field === 'incoming_save_section_name'){
      if(params.field === 'incoming_item_name' || params.field === 'incoming_item_spec'){
        setSelectModalTitle('품목 목록');
        setSelectItemModalOpen(true);
      } else if(params.field === 'incoming_save_workplace_name' || params.field === 'incoming_save_warehouse_name' || params.field === 'incoming_save_section_name'){
        setSelectModalTitle('창고 목록');
        setSelectWarehouseModalOpen(true);
      }
      setSelectModalType('I') // 품목 grid 에서 modal open
      setSelectItemData({
        id: params.row.id,
        incoming_item_id: params.row.incoming_item_id,
        incoming_item_name: params.row.incoming_item_name,
        incoming_item_spec: params.row.incoming_item_spec,
        incoming_item_count: params.row.incoming_item_count,
        incoming_quality_exam_yn: params.row.incoming_quality_exam_yn,
        incoming_save_workplace_id: params.row.incoming_save_workplace_id,
        incoming_save_workplace_name: params.row.incoming_save_workplace_name,
        incoming_save_warehouse_id: params.row.incoming_save_warehouse_id,
        incoming_save_warehouse_name: params.row.incoming_save_warehouse_name,
        incoming_save_section_id: params.row.incoming_save_section_id,
        incoming_save_section_name: params.row.incoming_save_section_name,
        row_type:params.row.row_type,
        update_type: params.row.update_type,
      })
    } else if(params.field === 'incoming_user_name'){
      setSelectModalTitle('사용자 목록')
      setSelectUserModalOpen(true);
      setSelectUserData({
        id: params.row.id,
        incoming_user_id: params.row.incoming_user_id,
        incoming_user_name: params.row.incoming_user_name,
        incoming_user_dept_name: params.row.incoming_user_dept_name,
        incoming_user_position_name: params.row.incoming_user_position_name,
        incoming_user_type: params.row.incoming_user_type,
        incoming_user_bigo: params.row.incoming_user_bigo,
        row_type: params.row.row_type,
        update_type: params.row.update_type
      })
    } else if(params.field === 'lot_incoming_save_workplace_name' || params.field === 'lot_incoming_save_warehouse_name' || params.field === 'lot_incoming_save_section_name'){
      // 02/20 수정 // 항상 창고목록만 열음음
      setSelectModalTitle('창고 목록');
      setSelectWarehouseModalOpen(true);

      setSelectModalType('L') // Lot grid 에서 modal open
      setSelectLotData({
        id: params.row.id,
        upper_id: params.row.upper_id,
        lot_no: params.row.lot_no,
        lot_incoming_item_id: params.row.lot_incoming_item_id,
        lot_incoming_item_name: params.row.lot_incoming_item_name,
        lot_incoming_item_spec: params.row.lot_incoming_item_spec,
        lot_incoming_quality_exam_yn: params.row.lot_incoming_quality_exam_yn,
        lot_incoming_save_workplace_id: params.row.lot_incoming_save_workplace_id,
        lot_incoming_save_workplace_name: params.row.lot_incoming_save_workplace_name,
        lot_incoming_save_warehouse_id: params.row.lot_incoming_save_warehouse_id,
        lot_incoming_save_warehouse_name: params.row.lot_incoming_save_warehouse_name,
        lot_incoming_save_section_id: params.row.lot_incoming_save_section_id,
        lot_incoming_save_section_name: params.row.lot_incoming_save_section_name,
        row_type: params.row.row_type,
        update_type: params.row.update_type,
      })
    }
  };

  const handlePartnerUserClick = (object) => {
    //입고처 모달에서 클릭한 값으로 입고처 및 담당자 데이터 설정함.
    var partner_user_name = object.partner_user_name === undefined?'':object.partner_user_name
    var partner_user_phone = object.partner_user_phone === undefined?'':object.partner_user_phone
    var partner_user_email = object.partner_user_email === undefined?'':object.partner_user_email

    const nextInputs = {
        ...inputs,
        ["incoming_partner_id"]: object.id,
        ["incoming_partner_name"]: object.partner_name,
        ["incoming_partner_manager"]: partner_user_name,
        ["incoming_partner_manager_phone"]: partner_user_phone,
        ["incoming_partner_manager_mail"]: partner_user_email,
        ["incoming_purchase_id"]: null,
        ["incoming_ref_incoming_id"]: null
    };
    setInputs(nextInputs);
  };
  
  const handleInputItemClick = (object) => {
    //품목 목록 모달에서 클릭한 값으로 입고 품목 데이터 설정함.
    var doubleYN = 'N'
    for(let i = 0; i < itemRows.length; i++){
      if(itemRows[i].incoming_item_id === object.id && selectItemData.id !== itemRows[i].id && object.id !== ''){
        doubleYN = 'Y'
      }
    }
    if(doubleYN === 'Y'){
      Swal.fire({
        title: '<p style="color:red">품목 '+object.item_name+' 중복</p>',
        text: '추가된 품목이므로 추가할 수 없습니다.',
        confirmButtonText: '확인'
      });
    } else {
      if(object.id !== selectItemData.incoming_item_id){
        processItemRowUpdate(
          {
            id: selectItemData.id,
            incoming_item_id: object.id,
            incoming_item_name: object.item_name,
            incoming_item_spec: object.item_spec,
            incoming_item_count: '',
            incoming_quality_exam_yn: selectItemData.incoming_quality_exam_yn,
            incoming_save_workplace_id: object.item_save_workplace_id,
            incoming_save_workplace_name: object.item_save_workplace_name,
            incoming_save_warehouse_id: object.item_save_warehouse_id,
            incoming_save_warehouse_name: object.item_save_warehouse_name,
            incoming_save_section_id: object.item_save_section_id,
            incoming_save_section_name: object.item_save_section_name,
            row_type:selectItemData.row_type,
            update_type: selectItemData.update_type,
          },
          {
            id: selectItemData.id,
            incoming_item_id: selectItemData.incoming_item_id,
            incoming_item_name: selectItemData.incoming_item_name,
            incoming_item_spec: selectItemData.incoming_item_spec,
            incoming_item_count: selectItemData.incoming_item_count,
            incoming_quality_exam_yn: selectItemData.incoming_quality_exam_yn,
            incoming_save_workplace_id: selectItemData.incoming_save_workplace_id,
            incoming_save_workplace_name: selectItemData.incoming_save_workplace_name,
            incoming_save_warehouse_id: selectItemData.incoming_save_warehouse_id,
            incoming_save_warehouse_name: selectItemData.incoming_save_warehouse_name,
            incoming_save_section_id: selectItemData.incoming_save_section_id,
            incoming_save_section_name: selectItemData.incoming_save_section_name,
            row_type:selectItemData.row_type,
            update_type: selectItemData.update_type,
          }
        )
      }
    }
  };

  const handleWorkplaceClick = (object) => {
    //사업장 모달
    if(selectModalType === 'I') { // 품목 grid 데이터 insert
      if(object.id !== selectItemData.incoming_save_workplace_id){
        processItemRowUpdate(
          {
            id: selectItemData.id,
            incoming_item_id: selectItemData.incoming_item_id,
            incoming_item_name: selectItemData.incoming_item_name,
            incoming_item_spec: selectItemData.incoming_item_spec,
            incoming_item_count: selectItemData.incoming_item_count,
            incoming_quality_exam_yn: selectItemData.incoming_quality_exam_yn,
            incoming_save_workplace_id: object.id,
            incoming_save_workplace_name: object.workplace_name,
            incoming_save_warehouse_id: selectItemData.incoming_save_warehouse_id,
            incoming_save_warehouse_name: selectItemData.incoming_save_warehouse_name,
            incoming_save_section_id: selectItemData.incoming_save_section_id,
            incoming_save_section_name: selectItemData.incoming_save_section_name,
            row_type:selectItemData.row_type,
            update_type: selectItemData.update_type,
          },
          {
            id: selectItemData.id,
            incoming_item_id: selectItemData.incoming_item_id,
            incoming_item_name: selectItemData.incoming_item_name,
            incoming_item_spec: selectItemData.incoming_item_spec,
            incoming_item_count: selectItemData.incoming_item_count,
            incoming_quality_exam_yn: selectItemData.incoming_quality_exam_yn,
            incoming_save_workplace_id: selectItemData.incoming_save_workplace_id,
            incoming_save_workplace_name: selectItemData.incoming_save_workplace_name,
            incoming_save_warehouse_id: selectItemData.incoming_save_warehouse_id,
            incoming_save_warehouse_name: selectItemData.incoming_save_warehouse_name,
            incoming_save_section_id: selectItemData.incoming_save_section_id,
            incoming_save_section_name: selectItemData.incoming_save_section_name,
            row_type:selectItemData.row_type,
            update_type: selectItemData.update_type,
          }
        )
      }
    } else if(selectModalType === 'L'){ // lot grid 데이터 insert
      if(object.id !== selectLotData.lot_incoming_save_workplace_id){
        processLotRowUpdate(
          {
            id: selectLotData.id,
            upper_id: selectLotData.upper_id,
            lot_no: selectLotData.lot_no,
            lot_incoming_item_id: selectLotData.lot_incoming_item_id,
            lot_incoming_item_name: selectLotData.lot_incoming_item_name,
            lot_incoming_item_spec: selectLotData.lot_incoming_item_spec,
            lot_incoming_item_count: selectLotData.lot_incoming_item_count,
            lot_incoming_quality_exam_yn: selectLotData.lot_incoming_quality_exam_yn,
            lot_incoming_save_workplace_id: object.id,
            lot_incoming_save_workplace_name: object.workplace_name,
            lot_incoming_save_warehouse_id: selectLotData.lot_incoming_save_warehouse_id,
            lot_incoming_save_warehouse_name: selectLotData.lot_incoming_save_warehouse_name,
            lot_incoming_save_section_id: selectLotData.lot_incoming_save_section_id,
            lot_incoming_save_section_name: selectLotData.lot_incoming_save_section_name,
            row_type:selectLotData.row_type,
            update_type: selectLotData.update_type,
          },
          {
            id: selectLotData.id,
            upper_id: selectLotData.upper_id,
            lot_no: selectLotData.lot_no,
            lot_incoming_item_id: selectLotData.lot_incoming_item_id,
            lot_incoming_item_name: selectLotData.lot_incoming_item_name,
            lot_incoming_item_spec: selectLotData.lot_incoming_item_spec,
            lot_incoming_item_count: selectLotData.lot_incoming_item_count,
            lot_incoming_quality_exam_yn: selectLotData.lot_incoming_quality_exam_yn,
            lot_incoming_save_workplace_id: selectLotData.lot_incoming_save_workplace_id,
            lot_incoming_save_workplace_name: selectLotData.lot_incoming_save_workplace_name,
            lot_incoming_save_warehouse_id: selectLotData.lot_incoming_save_warehouse_id,
            lot_incoming_save_warehouse_name: selectLotData.lot_incoming_save_warehouse_name,
            lot_incoming_save_section_id: selectLotData.lot_incoming_save_section_id,
            lot_incoming_save_section_name: selectLotData.lot_incoming_save_section_name,
            row_type:selectLotData.row_type,
            update_type: selectLotData.update_type,
          }
        )
      }
    }
  };

  const handleWarehouseClick = (object) => {
    //창고 모달
    if(selectModalType === 'I') { // 품목 grid 데이터 insert
      if((object.id !== selectItemData.incoming_save_warehouse_id) || object.section_cnt !== 0){
        if(object.section_cnt !== 0){ // 하위 section 정보가 있을 경우 section modal 켜줌
          setSelectModalTitle('구역 목록');
          setUpperWarehouseId(object.id);
          const nextSelectItemData = {  // 등록된 사업장/창고정보 갱신
            ...selectItemData,
            ['incoming_save_workplace_id'] : object.workplace_id,
            ['incoming_save_workplace_name'] : object.workplace_name,
            ['incoming_save_warehouse_id'] : object.id,
            ['incoming_save_warehouse_name'] : object.warehouse_name
          };
          setSelectItemData(nextSelectItemData);
          setSelectWarehouseSectionModalOpen(true);
        } else if (object.section_cnt === 0){
          processItemRowUpdate(
            {
              id: selectItemData.id,
              incoming_item_id: selectItemData.incoming_item_id,
              incoming_item_name: selectItemData.incoming_item_name,
              incoming_item_spec: selectItemData.incoming_item_spec,
              incoming_item_count: selectItemData.incoming_item_count,
              incoming_quality_exam_yn: selectItemData.incoming_quality_exam_yn,
              incoming_save_workplace_id: object.workplace_id,
              incoming_save_workplace_name: object.workplace_name,
              incoming_save_warehouse_id: object.id,
              incoming_save_warehouse_name: object.warehouse_name,
              incoming_save_section_id: null,
              incoming_save_section_name: '',
              row_type:selectItemData.row_type,
              update_type: selectItemData.update_type,
            },
            {
              id: selectItemData.id,
              incoming_item_id: selectItemData.incoming_item_id,
              incoming_item_name: selectItemData.incoming_item_name,
              incoming_item_spec: selectItemData.incoming_item_spec,
              incoming_item_count: selectItemData.incoming_item_count,
              incoming_quality_exam_yn: selectItemData.incoming_quality_exam_yn,
              incoming_save_workplace_id: selectItemData.incoming_save_workplace_id,
              incoming_save_workplace_name: selectItemData.incoming_save_workplace_name,
              incoming_save_warehouse_id: selectItemData.incoming_save_warehouse_id,
              incoming_save_warehouse_name: selectItemData.incoming_save_warehouse_name,
              incoming_save_section_id: selectItemData.incoming_save_section_id,
              incoming_save_section_name: selectItemData.incoming_save_section_name,
              row_type:selectItemData.row_type,
              update_type: selectItemData.update_type,
            }
          )
        }
      }
    } else if(selectModalType === 'L'){ // lot grid 데이터 insert
      if((object.id !== selectLotData.lot_incoming_save_warehouse_id) || object.section_cnt !== 0){
        if(object.section_cnt !== 0){ // 하위 section 정보가 있을 경우 section modal 켜줌
          setSelectModalTitle('구역 목록');
          setUpperWarehouseId(object.id);
          const nextSelectLotData = {  // 등록된 사업장/창고정보 갱신
            ...selectLotData,
            ['lot_incoming_save_workplace_id'] : object.workplace_id,
            ['lot_incoming_save_workplace_name'] : object.workplace_name,
            ['lot_incoming_save_warehouse_id'] : object.id,
            ['lot_incoming_save_warehouse_name'] : object.warehouse_name
          };
          setSelectLotData(nextSelectLotData);
          setSelectWarehouseSectionModalOpen(true);
        } else if (object.section_cnt === 0){
          processLotRowUpdate(
            {
              id: selectLotData.id,
              upper_id: selectLotData.upper_id,
              lot_no: selectLotData.lot_no,
              lot_incoming_item_id: selectLotData.lot_incoming_item_id,
              lot_incoming_item_name: selectLotData.lot_incoming_item_name,
              lot_incoming_item_spec: selectLotData.lot_incoming_item_spec,
              lot_incoming_item_count: selectLotData.lot_incoming_item_count,
              lot_incoming_quality_exam_yn: selectLotData.lot_incoming_quality_exam_yn,
              lot_incoming_save_workplace_id: object.workplace_id,
              lot_incoming_save_workplace_name: object.workplace_name,
              lot_incoming_save_warehouse_id: object.id,
              lot_incoming_save_warehouse_name: object.warehouse_name,
              lot_incoming_save_section_id: '',
              lot_incoming_save_section_name: '',
              row_type:selectLotData.row_type,
              update_type: selectLotData.update_type,
            },
            {
              id: selectLotData.id,
              upper_id: selectLotData.upper_id,
              lot_no: selectLotData.lot_no,
              lot_incoming_item_id: selectLotData.lot_incoming_item_id,
              lot_incoming_item_name: selectLotData.lot_incoming_item_name,
              lot_incoming_item_spec: selectLotData.lot_incoming_item_spec,
              lot_incoming_item_count: selectLotData.lot_incoming_item_count,
              lot_incoming_quality_exam_yn: selectLotData.lot_incoming_quality_exam_yn,
              lot_incoming_save_workplace_id: selectLotData.lot_incoming_save_workplace_id,
              lot_incoming_save_workplace_name: selectLotData.lot_incoming_save_workplace_name,
              lot_incoming_save_warehouse_id: selectLotData.lot_incoming_save_warehouse_id,
              lot_incoming_save_warehouse_name: selectLotData.lot_incoming_save_warehouse_name,
              lot_incoming_save_section_id: selectLotData.lot_incoming_save_section_id,
              lot_incoming_save_section_name: selectLotData.lot_incoming_save_section_name,
              row_type:selectLotData.row_type,
              update_type: selectLotData.update_type,
            }
          )
        }
      }
    }
  };

  const handleWarehouseSectionClick = (object) => {
    //구역 모달
    if(selectModalType === 'I') { // 품목 grid 데이터 insert
      if(object.id !== selectItemData.incoming_save_section_id){
        processItemRowUpdate(
          {
            id: selectItemData.id,
            incoming_item_id: selectItemData.incoming_item_id,
            incoming_item_name: selectItemData.incoming_item_name,
            incoming_item_spec: selectItemData.incoming_item_spec,
            incoming_item_count: selectItemData.incoming_item_count,
            incoming_quality_exam_yn: selectItemData.incoming_quality_exam_yn,
            incoming_save_workplace_id: selectItemData.incoming_save_workplace_id,
            incoming_save_workplace_name: selectItemData.incoming_save_workplace_name,
            incoming_save_warehouse_id: selectItemData.incoming_save_warehouse_id,
            incoming_save_warehouse_name: selectItemData.incoming_save_warehouse_name,
            incoming_save_section_id: object.id,
            incoming_save_section_name: object.section_name,
            row_type:selectItemData.row_type,
            update_type: selectItemData.update_type,
          },
          {
            id: selectItemData.id,
            incoming_item_id: selectItemData.incoming_item_id,
            incoming_item_name: selectItemData.item_name,
            incoming_item_spec: selectItemData.incoming_item_spec,
            incoming_item_count: selectItemData.incoming_item_count,
            incoming_quality_exam_yn: selectItemData.incoming_quality_exam_yn,
            incoming_save_workplace_id: selectItemData.incoming_save_workplace_id,
            incoming_save_workplace_name: selectItemData.incoming_save_workplace_name,
            incoming_save_warehouse_id: selectItemData.incoming_save_warehouse_id,
            incoming_save_warehouse_name: selectItemData.incoming_save_warehouse_name,
            incoming_save_section_id: selectItemData.incoming_save_section_id,
            incoming_save_section_name: selectItemData.incoming_save_section_name,
            row_type:selectItemData.row_type,
            update_type: selectItemData.update_type,
          }
        )
      }
    } else if(selectModalType === 'L'){ // lot grid 데이터 insert
      if(object.id !== selectLotData.lot_incoming_save_section_id){
        processLotRowUpdate(
          {
            id: selectLotData.id,
            upper_id: selectLotData.upper_id,
            lot_no: selectLotData.lot_no,
            lot_incoming_item_id: selectLotData.lot_incoming_item_id,
            lot_incoming_item_name: selectLotData.lot_incoming_item_name,
            lot_incoming_item_spec: selectLotData.lot_incoming_item_spec,
            lot_incoming_item_count: selectLotData.lot_incoming_item_count,
            lot_incoming_quality_exam_yn: selectLotData.lot_incoming_quality_exam_yn,
            lot_incoming_save_workplace_id: selectLotData.lot_incoming_save_workplace_id,
            lot_incoming_save_workplace_name: selectLotData.lot_incoming_save_workplace_name,
            lot_incoming_save_warehouse_id: selectLotData.lot_incoming_save_warehouse_id,
            lot_incoming_save_warehouse_name: selectLotData.lot_incoming_save_warehouse_name,
            lot_incoming_save_section_id: object.id,
            lot_incoming_save_section_name: object.section_name,
            row_type:selectLotData.row_type,
            update_type: selectLotData.update_type,
          },
          {
            id: selectLotData.id,
            upper_id: selectLotData.upper_id,
            lot_no: selectLotData.lot_no,
            lot_incoming_item_id: selectLotData.lot_incoming_item_id,
            lot_incoming_item_name: selectLotData.lot_incoming_item_name,
            lot_incoming_item_spec: selectLotData.lot_incoming_item_spec,
            lot_incoming_item_count: selectLotData.lot_incoming_item_count,
            lot_incoming_quality_exam_yn: selectLotData.lot_incoming_quality_exam_yn,
            lot_incoming_save_workplace_id: selectLotData.lot_incoming_save_workplace_id,
            lot_incoming_save_workplace_name: selectLotData.lot_incoming_save_workplace_name,
            lot_incoming_save_warehouse_id: selectLotData.lot_incoming_save_warehouse_id,
            lot_incoming_save_warehouse_name: selectLotData.lot_incoming_save_warehouse_name,
            lot_incoming_save_section_id: selectLotData.lot_incoming_save_section_id,
            lot_incoming_save_section_name: selectLotData.lot_incoming_save_section_name,
            row_type:selectLotData.row_type,
            update_type: selectLotData.update_type,
          }
        )
      }
    }
  };

  const handleUserClick = (object) => {
    //입고담당자 모달에서 클릭한 값으로 입고담당자 데이터 설정함.
    var doubleYN = 'N' 
    for(let i = 0; i < userRows.length; i++){
      if(userRows[i].incoming_user_id === object.id && selectUserData.id !== userRows[i].id && object.id !== ''){
        doubleYN = 'Y'
      }
    }
    if(doubleYN === 'Y'){
      Swal.fire({
        title: '<p style="color:red">담당자 '+object.user_name+' 중복</p>',
        text: '추가된 담당자이므로, 중복으로 추가할 수 없습니다.',
        confirmButtonText: '확인'
      });
    } else {
      if(object.id !== selectUserData.user_id){
        processUserRowUpdate(
          {
            id : selectUserData.id,
            incoming_user_id: object.id,
            incoming_user_name: object.user_name,
            incoming_user_dept_name: object.dept_name,
            incoming_user_position_name: object.position_name,
            incoming_user_type: selectUserData.incoming_user_type,
            incoming_user_bigo: selectUserData.incoming_user_bigo,
            row_type: selectUserData.row_type,
            update_type: selectUserData.update_type
          },
          {
            id : selectUserData.id,
            incoming_user_id: selectUserData.incoming_user_id,
            incoming_user_name: selectUserData.incoming_user_name,
            incoming_user_type: selectUserData.incoming_user_type,
            incoming_user_dept_name: selectUserData.incoming_user_dept_name,
            incoming_user_position_name: selectUserData.incoming_user_position_name,
            incoming_user_bigo: selectUserData.incoming_user_bigo,
            row_type: selectUserData.row_type,
            update_type: selectUserData.update_type
          }
        )
      }
    }
  };

  const handleSave = (event) => {

    let msg = '';

    if(inputs.incoming_partner_id === 0 || inputs.incoming_partner_id === ''){
      msg = '입고처는 필수 선택 입니다.'
    }else if((inputs.incoming_date) === '' || (inputs.incoming_date) < '2025-01-01' || (inputs.incoming_date).length != 10){
      msg = '입고일자 입력이 올바르지 않습니다.<br/>(입력 양식 : 2025-01-01 ~ )'
    }else if(inputs.incoming_partner_manager_phone.trim() !== '' && !(/^\d{3}-(\d{3,4})-\d{4}$/).test(inputs.incoming_partner_manager_phone.trim())){
      msg = '담당자 휴대번호 입력이 올바르지 않습니다.<br/>(입력 양식 : 010-숫자3,4자리-숫자4자리)';
    }else if(inputs.incoming_partner_manager_mail.trim() !== '' && !(/^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{1,5}$/).test(inputs.incoming_partner_manager_mail.trim())){
      msg = '담당자 E-Mail 입력이 올바르지 않습니다.';
    }

    if(msg === '' && (itemRows.filter((data) => (data.update_type !== 'D' && (data.row_type !== 'A' || data.update_type !== 'N')))).length === 0){ // 입고품목이 0개 일 경우

      msg = '입고 품목이 존재하지 않습니다.';

    }else if(msg === '' && updateItemRows.length > 0){ // 입고품목 검사
      for(let i = 0; i < updateItemRows.length; i++) {
        const incoming_item_id = updateItemRows[i].incoming_item_id;
        const incoming_item_count = updateItemRows[i].incoming_item_count;

        if(incoming_item_id === 0 || incoming_item_id === '') {
          msg = '선택되지 않는 입고 품목이 존재합니다.';
          break;
        }
        if(incoming_item_count === 0 || incoming_item_count === '' || incoming_item_count === null) {
          msg = '입력되지 않는 입고 수량이 존재합니다.';
          break;
        }
        if(incoming_item_count < 0) {
          msg = '입고 수량은 음수가 될 수 없습니다.';
          break;
        }
      }
    }

    // 입고담당자
    if(msg === '' && (userRows.filter((data) => data.update_type === 'U')).length > 0){
      if(updateUserRows.length > 0 && msg === ''){
        for(let i = 0; i < updateUserRows.length; i++) {
          const incoming_user_id = updateUserRows[i].incoming_user_id;
          const incoming_user_type = updateUserRows[i].incoming_user_type;
          
          if(incoming_user_id === 0 || incoming_user_id === '') {
            msg = '선택되지 않는 담당자명이 존재합니다.';
            break;
          }
          if(incoming_user_type === 0 || incoming_user_type === '') {
            msg = '선택되지 않는 담당자유형이 존재합니다.';
            break;
          }
        }
      }
    }
    
    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">입고 수정 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }else{
      if (appStore.loading) return;
      appStore.setLoading(true);

      axios.post("/api/p/Incoming/Reg", {inputs, updateItemRows, updateUserRows, updateLotRows} ,
      { withCredentials: true })
      .then(function (response) {
        if(response.status === 200){

          if(updateFileRows.length > 0) {

            var selectID = inputs.incoming_id;
            const formData = new FormData();
            formData.append('selectID', selectID);
            formData.append('folder', 'Incoming');
            formData.append('type', 'Update');
            formData.append('updateFileRows', JSON.stringify(updateFileRows));
            
            for(var i=0; i<realFiles.length; i++){            
              formData.append('files', realFiles[i]);
            }
            
            axios.post('/api/SaveCommon/GridFileSave'
                , formData
                , { headers: { 'Content-Type': 'multipart/form-data' } 
            }).then(response => {
              Swal.fire({
                title: '입고 수정 완료',
                text: '정상적으로 입고가 수정 되었습니다.',
                confirmButtonText: '확인',
                timer:5000,
                timerProgressBar: true
              }).then((result) => {
                handleView();
              });
            }).catch(error => {
              appStore.capture();
            });

          }else{

            Swal.fire({
              title: '입고 수정 완료',
              text: '정상적으로 입고가 수정 되었습니다.',
              confirmButtonText: '확인',
              timer:5000,
              timerProgressBar: true
            }).then((result) => {
              handleView();
            });
            
          }
        }else{
          appStore.capture();
        }
      })
      .catch(function (error) {
          appStore.capture();
      })
      .finally(() => {
          appStore.setLoading(false); 
      });

    }
  };
  
  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{ height: 'auto', overflowY: 'auto'}}>
          <TabContext value={tabID}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                <Tab label="입고 정보" value="1" />
                <Tab label="입고 품목" value="2" />
                <Tab label="입고 Lot" value="3" />
                <Tab label="입고 담당자" value="4" />
                <Tab label="입고 파일" value="5" />
              </TabList>
            </Box>
            <TabPanel value="1" ref={tabPanelRef}>
              <table className="ModalTABLE">
                <tbody>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">입고번호</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="입고번호" value={inputs.incoming_number} name="incoming_number" onChange={(e) => onChange(e) } autoComplete="off" disabled={true}  style={ { fontWeight:'bold', color: 'black' } } />
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">발주번호</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="발주번호" value={inputs.incoming_purchase_number} name="incoming_purchase_number" onChange={(e) => onChange(e) } autoComplete="off" disabled={true}  style={ { fontWeight:'bold', color: 'black' } } />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">입고일자<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="date" placeholder="입고일자" value={inputs.incoming_date} name="incoming_date" onChange={(e) => onDateChange(e) } autoComplete="off" style={{backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black', cursor: 'pointer' }} readOnly />
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">입고처<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="입고처" value={inputs.incoming_partner_name} name="incoming_partner_name" onChange={(e) => onChange(e) } onClick={(e) => onClick(e) } autoComplete="off" style={{backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black', cursor: 'pointer' }} readOnly />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">입고처담당자</div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '768px' } }>
                          <input type="text" placeholder="이름" value={inputs.incoming_partner_manager} name="incoming_partner_manager" onChange={(e) => onChange(e) } style={{ float: 'left', width: '112px', marginRight: '15px' }} autoComplete="off" />
                          <input type="text" placeholder="휴대폰번호" value={inputs.incoming_partner_manager_phone} name="incoming_partner_manager_phone" onChange={(e) => onHypenChange(e) } style={{ float: 'left', width: '300px', marginRight: '15px' }} autoComplete="off" />
                          <input type="text" placeholder="메일주소" value={inputs.incoming_partner_manager_mail} name="incoming_partner_manager_mail" onChange={(e) => onChange(e) } style={{width: '360px'}} autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">비고</div>
                        <div className="modal_filed_input">
                          <textarea placeholder="비고" name="incoming_bigo" value={inputs.incoming_bigo} onChange={(e) => onChange(e) } style={{width: '768px', height: '200px', marginTop:'10px', border:'2px lightgrey solid', borderRadius: '5px', fontSize:'17px', fontFamily:'none', resize:'none'}} autoComplete="off">
                          </textarea>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </TabPanel>
            <TabPanel value="2" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={itemRows}
                  columns={itemColumns}
                  columnVisibilityModel={itemColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processItemRowUpdate}        
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="3" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={lotRows}
                  columns={lotColumns}
                  columnVisibilityModel={lotColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processLotRowUpdate}        
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="4" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={userRows}
                  columns={userColumns}
                  columnVisibilityModel={userColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processUserRowUpdate}        
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="5" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  rows={fileRows}
                  columns={fileColumns}
                  columnVisibilityModel={fileColumnVisibilityModel}
                  editMode='cell'   
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
          </TabContext>
          <table className="ModalTABLE">
            <tbody>
              <tr>
                <td className="ModalTD" colSpan={2}>
                  <div className="modal_action">
                  <div className="modal_button" style={{float: 'left'}}>
                    {updateFlag &&
                    (originRows[0].incoming_status === 'S'?
                      <Button 
                        onClick={ handleIncomingUpdate }
                        className="btn-p btn-u"
                        style={{width: '130px'}}
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "orange", 
                            backgroundColor: "orange",
                            ":hover": { boxShadow: "2px 2px 2px orange" , backgroundColor: "orange", borderColor: "orange"}
                        }} 
                        variant="outlined">
                        입고취소
                      </Button>
                    :
                      <Button 
                        onClick={ handleIncomingUpdate }
                        className="btn-p btn-u"
                        style={{width: '130px'}}
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#8041D9", 
                            backgroundColor: "#8041D9",
                            ":hover": { boxShadow: "2px 2px 2px #8041D9" , backgroundColor: "#8041D9", borderColor: "#8041D9"}
                        }} 
                        variant="outlined">
                        입고원복
                      </Button>
                      )
                    }
                    </div>
                    <div className="modal_button">
                      <Button 
                        onClick={()=> { onClose?.(); }}
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#808080", 
                            backgroundColor: "#808080",
                            ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                        }} 
                        variant="outlined">
                        닫기
                      </Button>
                    </div>
                    <div className="modal_button">
                      {updateFlag &&
                      (originRows[0].incoming_status === 'S'?
                      <Button 
                        onClick={handleSave}
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        수정
                      </Button>:<></>
                      )}
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {isSelectPartnerModalOpen && (<PartnerUserSelectModal
          onClose={() => {
              setSelectPartnerModalOpen(false);
          }}
          title={selectmodalTitle}
          handlePartnerUserClick={handlePartnerUserClick}
          />)}

        {isSelectItemModalOpen && (<ItemSelectModal
          onClose={() => {
              setSelectItemModalOpen(false);
          }}
          title={selectmodalTitle}
          handleInputItemClick={handleInputItemClick}
          />)}

        {isSelectWorkplaceModalOpen && (<WorkplaceSelectModal
          onClose={() => {
              setSelectWorkplaceModalOpen(false);
          }}
          title={selectmodalTitle}
          handleWorkplaceClick={handleWorkplaceClick}
          />)}

        {isSelectWarehouseModalOpen && (<WarehouseSelectModal
            onClose={() => {
                setSelectWarehouseModalOpen(false);
            }}
            title={selectmodalTitle}
            upperWorkplaceId={upperWorkplaceId}
            handleWarehouseClick={handleWarehouseClick}
            />)}

        {isSelectWarehouseSectionModalOpen && (<WarehouseSectionSelectModal
            onClose={() => {
                setSelectWarehouseSectionModalOpen(false);
            }}
            title={selectmodalTitle}
            upperWarehouseId={upperWarehouseId}
            handleWarehouseSectionClick={handleWarehouseSectionClick}
            />)}

        {isSelectUserModalOpen && (<UserSelectModal
          onClose={() => {
              setSelectUserModalOpen(false);
          }}
          title={selectmodalTitle}
          handleUserClick={handleUserClick}
          />)}
    </PCModal>
  );
}

export default IncomingUpdateModal;